import React, {useMemo} from 'react';
import Style from './index.module.scss';
import * as IconMobile from 'antd-mobile-icons';
import IconRender from '../../IconRender';
import {IconType} from '../../../Utils/publicEnum';
import {Button, Col, Drawer, Row} from 'antd';
import {useToggle} from 'react-use';
import AntdIcons from './antdName.json';

interface Props {
    value?: string;
    onChange?: (value: string) => void;
    iconType: IconType;
}

const Index = ({value, onChange, iconType}: Props) => {
    const defaultIcons = useMemo(() => {
        switch (iconType) {
            case IconType.Antd:
                return AntdIcons;
            case IconType.AntdMobile:
                return Object.keys(IconMobile);
            default:
                return [];
        }
    }, [iconType]);

    const [show, toggleShow] = useToggle(false);

    function onSelect(icon: string) {
        onChange?.(icon);
        toggleShow();
    }

    return (
        <div className={Style.root}>
            {value ? (
                <IconRender
                    onClick={toggleShow}
                    type={iconType}
                    value={value}
                    className={Style.iconDefault}
                />
            ) : (
                <Button onClick={toggleShow}>点击选择</Button>
            )}

            <Drawer
                title="图标选择"
                open={show}
                onClose={toggleShow}
                width={1000}>
                <div>
                    <Row>
                        {defaultIcons.map(item => (
                            <Col key={item} span={4} style={{marginBottom: 15}}>
                                <IconRender
                                    onClick={() => onSelect(item)}
                                    className={Style.icon}
                                    type={iconType}
                                    value={item}
                                />
                            </Col>
                        ))}
                    </Row>
                </div>
            </Drawer>
        </div>
    );
};

export default Index;
